interface CenteredSpinnerProps {
  label?: string;
}

export function CenteredSpinner({ label }: CenteredSpinnerProps): JSX.Element {
  return (
    <div className="spinner-block" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      {label ? <span className="spinner__label">{label}</span> : null}
    </div>
  );
}
